import {PolylineEdge, PolylineEdgeModel} from '@logicflow/core';

class SequenceModel extends PolylineEdgeModel {

    setAttributes() {
        const {properties} = this;
        if (properties.animation) {
            this.isAnimation = true
        }

    }

    getEdgeStyle() {
        const style = super.getEdgeStyle();
        const {properties} = this;

        style.strokeWidth = 1
        if (properties.finish === true) {
            style.strokeWidth = 3
        }

        if (properties.skin_stroke) {
            style.stroke = properties.skin_stroke;
        }

        if (properties.style_stroke) {
            style.stroke = properties.style_stroke;
        }
        return style;
    }

}

export default {
    type: 'prc-polyline',
    view: PolylineEdge,
    model: SequenceModel,
};